import { render, staticRenderFns } from "./LastNews.vue?vue&type=template&id=c759559c&scoped=true"
import script from "./LastNews.vue?vue&type=script&lang=ts"
export * from "./LastNews.vue?vue&type=script&lang=ts"
import style0 from "./LastNews.vue?vue&type=style&index=0&id=c759559c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c759559c",
  null
  
)

export default component.exports